const ENVINFO = import.meta.env;
const config = {};
Object.keys(ENVINFO).forEach(key => {
    try {
        config[key] = JSON.parse(ENVINFO[key]);
    } catch (e) {
        config[key] = ENVINFO[key]
    }
})

console.log(config)
export default {
    version: VITE_PACKAGE.version,

    // 请求日志
    httpLog: true,

    modalApi: {
        myouApi: config.VITE_M_URL + '/findu_api/api',
        whApi: config.VITE_DOMAIN_BASE_URL + '/wh_api/api',
    },

    httpSign: config.VITE_HTTP_SIGN,

    qqMap: {
        key: config.VITE_QQ_MAP_KEY,
        sig: config.VITE_QQ_MAP_SIG
    },
    // #ifdef MP-WEIXIN
    appid: config.VITE_APP_ID,
    // #endif

    // #ifdef H5
    appid: config.VITE_H5_ID,
    // #endif

    router: {
        routes: ROUTES,
        routesMap: ROUTES_MAP,
        routesAliasMap: ROUTES_ALIAS_MAP,
        routesTabBar: ROUTES_TABBAR
    },

    // #ifdef H5
    client:'wxH5',
    // #endif

    // #ifdef MP-WEIXIN
    client:'xapp',
    // #endif

    templateIds: {
        // 订单
        // 商务助理已确认接单的订单，被客户取消，进行订阅消息通知
        'orderCancelled': "ztvK3rBpRSW6YU8jBbiZtJYAZn-0LagKe0p8F56p1yM",
        // 商务助理收到新订单，进行订阅消息通知
        'orderAlerts': 'oB86QRm8zrv8OGrddUryR9Pyd13xqGT7_suyszqD_OM',
        // 客户取消已确认支付的订单，商务助理收到订单补偿款，进行订阅消息通知
        'compensationMsg': '61O1xeL_EjBS-ujle0q_n39c7guRLnTl1fY5oyuDyeU',

        // 助理认证
        // 认证结果通知
        'notificationOfCertificationResults': 'pGIgVa8-Ff704leTuMH3pzr5PZNoQ1UUwIyPbvgr-8s',
        // 审核结果通知
        'findingsOfAudit': 'wP2uoi2V9EEtbMAsMM15ny4ssEH6-19M09sparbgkNY',


        // 客户
        // 客户订单被接单，进行订阅消息通知
        'receivedOrderReminder': 'SLpOTNgI1l6uDI-02Xynzqe9bWmRU_wAKxmdTkZl_3Y',
        // 客户最新的一笔的订单已完成，未进行评价，进行订阅消息通知
        'toEvaluate': 'Qj3xoM_QyNuep0RrzQECndve3SrC_aJFXWAmoK-PXjE',
        // 客户退款成功，进行订阅消息通知
        'returnSuccessful': 'WCDy7Oj8PAMdLx68X5TZgHSI9D9D-GQ43XsRxrJ5n7g',
        // 客户取消已完成支付的订单，进行订阅消息通知
        'cancelPaidOrders': 'JqmYeUd6pRZrBPCRtbY0WRdOPCG4CdIUG1MkvxAwj4A',
    },

    h5: {
        domain: config.VITE_H5_DOMAIN_PATH,
        vipPath: config.VITE_H5_BUSINESS_PATH + config.VITE_VIP_PATH,
        placePath: config.VITE_H5_BUSINESS_PATH + config.VITE_PLACE_PATH,
        orderDetailPath: config.VITE_H5_BUSINESS_PATH + config.VITE_ORDER_DETAIL_PATH,
        waiterOrderDetailPath: config.VITE_H5_BUSINESS_PATH + config.VITE_WAITER_ORDER_DETAIL_PATH,
        serverListPath: config.VITE_H5_BUSINESS_PATH + config.VITE_SERVER_LIST_PATH,
        myWalletPath: config.VITE_H5_BUSINESS_PATH + config.VITE_MY_WALLET_PATH,
        inviteMoneyPath: config.VITE_H5_BUSINESS_PATH + config.VITE_INVITE_MONEY_PATH,
        shareCardLandPath: config.VITE_H5_BUSINESS_PATH + config.VITE_SHARE_CARD_LAND_PATH,
        vipShareCardRecordPath: config.VITE_H5_BUSINESS_PATH + config.VITE_VIP_SHARE_CARD_RECORD_PATH,
        vipShareCardRulePath: config.VITE_H5_BUSINESS_PATH + config.VITE_VIP_SHARE_CARD_RULE_PATH,
        billPlacePath: config.VITE_H5_BUSINESS_PATH + config.VITE_BILL_PLACE_PATH,
    },

    h5DirectUrl: config.VITE_H5_REDIRECT_URL,

    ...config
}
